<template>
  <v-container style="max-width: 1140px;">
    <h1 class="display-1 mb-3">Dashboard</h1>
    <p>Thanks for helping to make Warner Center more walkable! This tool will ask you to identify barriers and strengths that impact your ability to walk around the area. Please tap "Get Started" below to begin your walk audit. </p>
    <v-btn block color="secondary" class="my-4" @click="gotoAudit">Get Started</v-btn>
    <br>
  <v-img
    align-top
    width="100%"
    src="img/hero/DSC02612.jpg"
    gradienta="to top right, rgba(100,115,201,.43), rgba(25,32,72,.7)">
  </v-img>    
  </v-container>
</template>

<script>
  export default {
    methods: {
      gotoAudit () {
        this.$router.push({ name: 'audit' })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>